import React, { ReactNode } from "react";

import { QueryProvider } from "src/components/providers/QueryProvider";
import { Provider as ReduxProvider } from "react-redux";
import { IntlProvider } from "src/i18n/IntlProvider";

import "src/styles/global.css";
import "src/styles/variables.css";
import { store } from "src/store";

type Props = {
  children: ReactNode;
};

export const Provider: React.FC<Props> = ({ children }) => (
  <QueryProvider>
    <ReduxProvider store={store}>
      <IntlProvider>{children}</IntlProvider>{" "}
    </ReduxProvider>
  </QueryProvider>
);
